<template>
    <div class="chart-wrapper" :class="{ 'custom-title ': isCustomHeader }">
        <lottery-info-container clickable customClass="p-4">
            <template #top>
                <div v-if="isCustomHeader" class="px-4 pt-4">
                    <div class="custom-chart-header">
                        <h6 class="title mb-0">
                            {{ customHeaderTitle }}
                            <span class="star text-dark">*</span>
                        </h6>
                        <span class="subtitle">
                            <span class="star text-dark">*</span>
                            {{ customHeaderSubtitle }}
                        </span>
                    </div>
                </div>

                <vue-apex-charts
                    v-if="isChartConfigured"
                    class="dashboard-graph"
                    :options="options"
                    :series="series"
                ></vue-apex-charts>
            </template>
        </lottery-info-container>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import LotteryInfoContainer from '@/components/lottery/LotteryInfoContainer.vue'

export default {
    name: 'DashboardChart',
    components: { VueApexCharts, LotteryInfoContainer },
    props: {
        chartOptions: {
            type: Object,
            required: true
        },
        customHeaderTitle: {
            type: String,
            required: false
        },
        customHeaderSubtitle: {
            type: String,
            required: false
        },
        isCustomHeader: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        if (this.isCustomHeader) {
            this.isChartConfigured = true
            return
        }

        this.options.title = {
            text: this.chartOptions.title,
            align: 'left',
            margin: 30,
            offsetX: 8,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
                fontFamily: 'Red Hat Display',
                color: '#041E42'
            }
        }
        this.isChartConfigured = true
    },
    data() {
        return {
            isChartConfigured: false,
            options: {
                chart: {
                    zoom: { enabled: false },
                    type: 'area',
                    toolbar: {
                        show: false
                    },
                    height: 300
                },
                xaxis: {
                    categories: this.chartOptions.categories
                },
                responsive: [
                    {
                        breakpoint: 400,
                        options: {
                            title: {
                                offsetY: 5,
                                style: {
                                    fontSize: '13px'
                                }
                            }
                        }
                    }
                ],
                colors: this.chartOptions.colors,
                stroke: {
                    curve: 'smooth'
                },
                legend: {
                    enabled: false
                },
                dataLabels: {
                    enabled: false
                }
            },
            series: this.chartOptions.series
        }
    }
}
</script>

<style lang="scss">
.chart-wrapper {
    &.custom-title {
        background-color: #fff;
        border: 1px solid var(--color-gray-300);
        border-radius: 0.3125rem;
        .dashboard-graph {
            border: none;
        }
        .subtitle {
            font-size: 12px;
        }
    }
}
</style>
